import queryString from 'query-string';
import xhr from 'xhr';
import storage from '../lib/storage';
import { uploadProject } from '../common/tencentCos';
import { ProjectApi } from '../api/project';

/**
 * Save a project JSON to the project server.
 * This should eventually live in scratch-www.
 * @param {number} projectId the ID of the project, null if a new project.
 * @param {object} vmState the JSON project representation.
 * @param {object} params the request params.
 * @property {?number} params.originalId the original project ID if a copy/remix.
 * @property {?boolean} params.isCopy a flag indicating if this save is creating a copy.
 * @property {?boolean} params.isRemix a flag indicating if this save is creating a remix.
 * @property {?string} params.title the title of the project.
 * @return {Promise} A promise that resolves when the network request resolves.
 */
export default function (projectId, vmState, params) {

    console.log(projectId, vmState, params)
    //                            params还包含authorId 目的是为了管理员可以修改别人的作品
    //1.更新 ID , json字符串 , {"title": "Scratch作品",uuid: '550e8400-e29b-41d4-a716-446655440000'}   标题自己去state里面取了传进来了
    //2.另存 null, json字符串 , {"originalId": "1","isCopy": 1,"title": "Scratch作品",uuid: "...(存在但应另外生成)"}
    //3.新建 null, json字符串 , {"title": "Scratch作品",uuid: null}
    let { title, uuid, originalId, isCopy, authorId } = params
    if (!uuid || isCopy) {
        uuid = crypto.randomUUID()
        authorId = null //是另存或者新建的话，实际作者ID在后端获得
    }

    return new Promise((resolve, reject) => {
        const objectKey = `${uuid}.json`;
        uploadProject(objectKey, vmState, (err, data) => {
            if (err) reject(err)
        })
        ProjectApi.saveProject({
            projectID: parseInt(projectId),
            title: title,
            authorId: authorId,//其实通过id的有无就可以判断是修改作品了，修改作品的时候不去改作者 这里没必要传
            uuid: uuid,
            // cover: null,//封面 之后就做
            // published: published,//是否发布 后面打算增加用户（或管理员）在编辑作品时编辑这些属性的功能 所以要传
            // openSource:openSource,//是否开源 同上
            originalId: parseInt(originalId),//改编自哪里，原作品ID 注意改编的作品也可能是改编自别人的，后端要额外判断
        }).then((data) => {
            console.log(data)
            if (data.status === "ok") {
                resolve({ id: data.pid, uuid: uuid })
            } else {
                reject("保存失败")
            }
        })
        // resolve({ data: "asd", msg: "test", id: 12 })
    })

    // eslint-disable-next-line no-unreachable
    // const opts = {
    //     body: vmState,
    //     // If we set json:true then the body is double-stringified, so don't
    //     headers: {
    //         'Content-Type': 'application/json'
    //     },
    //     withCredentials: true
    // };
    // const creatingProject = projectId === null || typeof projectId === 'undefined';
    // const queryParams = {};
    // if (params.hasOwnProperty('originalId')) queryParams.original_id = params.originalId;
    // if (params.hasOwnProperty('isCopy')) queryParams.is_copy = params.isCopy;
    // if (params.hasOwnProperty('isRemix')) queryParams.is_remix = params.isRemix;
    // if (params.hasOwnProperty('title')) queryParams.title = params.title;
    // let qs = queryString.stringify(queryParams);
    // if (qs) qs = `?${qs}`;
    // if (creatingProject) {
    //     Object.assign(opts, {
    //         method: 'post',
    //         url: `${storage.projectHost}/${qs}`
    //     });
    // } else {
    //     Object.assign(opts, {
    //         method: 'put',
    //         url: `${storage.projectHost}/${projectId}${qs}`
    //     });
    // }
    // return new Promise((resolve, reject) => {
    //     xhr(opts, (err, response) => {
    //         if (err) return reject(err);
    //         if (response.statusCode !== 200) return reject(response.statusCode);
    //         let body;
    //         try {
    //             // Since we didn't set json: true, we have to parse manually
    //             body = JSON.parse(response.body);
    //         } catch (e) {
    //             return reject(e);
    //         }
    //         body.id = projectId;
    //         if (creatingProject) {
    //             body.id = body['content-name'];
    //         }
    //         resolve(body);
    //     });
    // });
}
